<template>
  <div class="wrap">
    <!--符号 start-->
    <div class="mul1">×</div>
    <div class="mul2">×</div>
    <div class="tit">=净资产收益率×(1-股利支付比率)</div>
    <div class="div1">|</div>
    <div class="div2"></div>
    <div class="div3"></div>
    <div class="div4"></div>
    <div class="div5"></div>

    <div class="div6"></div>
    <div class="div7"></div>
    <div class="div8"></div>

    <div class="div9"></div>
    <div class="div10"></div>
    <div class="div11"></div>

    <div class="div12"></div>
    <div class="div13"></div>
    <div class="div14"></div>

    <div class="div15"></div>
    <div class="div16"></div>
    <div class="div17"></div>

    <div class="div18"></div>
    <div class="div19"></div>
    <div class="div20"></div>

    <div class="div21"></div>
    <div class="div22"></div>
    <div class="div23"></div>

    <div class="div24"></div>
    <div class="div26"></div>

    <div class="div27"></div>
    <div class="div28"></div>

    <!--符号   end-->

    <div class="node node-row-1">
      <p class="key">{{flowChart[0].indicator_name}}</p>
      <p class="value">{{flowChart[0].fact_value}}</p>
    </div>

    <div class="link h-linktwo-1"></div>

    <!-- 二 -->
    <div class="node node-row-2-1">
      <p class="key">{{flowChart[1].indicator_name}}(%)</p>
      <p class="value">{{flowChart[1].fact_value}}</p>
    </div>
    <div class="node node-row-2-2">
      <p class="key">{{flowChart[2].indicator_name}}(%)</p>
      <p class="value">{{flowChart[2].fact_value}}</p>
    </div>

    <div class="link h-rootlink"></div>

    <!-- 三 -->

    <div class="node node-row-3-1">
      <p class="key">{{flowChart[3].indicator_name}}(%)</p>
      <p class="value">{{flowChart[3].fact_value}}</p>
    </div>
    <div class="node node-row-3-2">
      <p class="key">{{flowChart[4].indicator_name}}(次)</p>
      <p class="value">{{flowChart[4].fact_value}}</p>
    </div>
    <div class="node node-row-3-3">
      <p class="key">{{flowChart[5].indicator_name}}</p>
      <p class="value">{{flowChart[5].fact_value}}</p>
    </div>

    <!-- 四 -->
    <div class="node node-row-4-1">
      <p class="key">{{flowChart[6].indicator_name}}(%)</p>
      <p class="value">{{flowChart[6].fact_value}}</p>
    </div>
    <div class="node node-row-4-2">
      <p class="key">{{flowChart[14].indicator_name}}(次)</p>
      <p class="value">{{flowChart[14].fact_value}}</p>
    </div>
    <div class="node node-row-4-3">
       <p class="key">{{flowChart[20].indicator_name}}</p>
      <p class="value">{{flowChart[20].fact_value}}</p>
    </div>
    <!-- 五 -->
    <div class="node node-row-5-1">
      <p class="key">{{flowChart[7].indicator_name}}(%)</p>
      <p class="value">{{flowChart[7].fact_value}}</p>
    </div>

    <div class="node node-row-5-2">
      <p class="key">{{flowChart[15].indicator_name}}(次)</p>
      <p class="value">{{flowChart[15].fact_value}}</p>
    </div>

    <div class="node node-row-5-3">
      <p class="key">{{flowChart[21].indicator_name}}</p>
      <p class="value">{{flowChart[21].fact_value}}</p>
    </div>
    <!-- 六 -->
    <div class="node node-row-6-1">
      <p class="key">{{flowChart[8].indicator_name}}(%)</p>
      <p class="value">{{flowChart[8].fact_value}}</p>
    </div>
    <div class="node node-row-6-2">
      <p class="key">{{flowChart[16].indicator_name}}(次)</p>
      <p class="value">{{flowChart[16].fact_value}}</p>
    </div>
    <div class="node node-row-6-3">
        <p class="key">{{flowChart[22].indicator_name}}(%)</p>
      <p class="value">{{flowChart[22].fact_value}}</p>
    </div>
    <!-- 七 -->
    <div class="node node-row-7-1">
      <p class="key">{{flowChart[9].indicator_name}}(%)</p>
      <p class="value">{{flowChart[9].fact_value}}</p>
    </div>
    <div class="node node-row-7-2">
       <p class="key">{{flowChart[17].indicator_name}}(次)</p>
      <p class="value">{{flowChart[17].fact_value}}</p>
    </div>
    <div class="node node-row-7-3">
      <p class="key">{{flowChart[23].indicator_name}}(%)</p>
      <p class="value">{{flowChart[23].fact_value}}</p>
     
    </div>
    <!-- 八 -->
    <div class="node node-row-8-1">
      <p class="key">{{flowChart[10].indicator_name}}(%)</p>
      <p class="value">{{flowChart[10].fact_value}}</p>
    </div>
    <div class="node node-row-8-2">
       <p class="key">{{flowChart[18].indicator_name}}(次)</p>
      <p class="value">{{flowChart[18].fact_value}}</p>
     
    </div>
    <div class="node node-row-8-3">
      <p class="key">{{flowChart[24].indicator_name}}(%)</p>
      <p class="value">{{flowChart[24].fact_value}}</p>
     
    </div>
    <!-- 9 -->
    <div class="node node-row-9-1">
      <p class="key">{{flowChart[11].indicator_name}}(%)</p>
      <p class="value">{{flowChart[11].fact_value}}</p>
    </div>
    <div class="node node-row-9-2">
       <p class="key">{{flowChart[19].indicator_name}}(次)</p>
      <p class="value">{{flowChart[19].fact_value}}</p>
   
    </div>
    <div class="node node-row-9-3">
       <p class="key">{{flowChart[25].indicator_name}}(%)</p>
      <p class="value">{{flowChart[25].fact_value}}</p>
      
    </div>
    <!-- 10 -->
    <div class="node node-row-10-1">
      <p class="key">{{flowChart[12].indicator_name}}(%)</p>
      <p class="value">{{flowChart[12].fact_value}}</p>
    </div>
    <div class="node node-row-10-3">
      <p class="key">{{flowChart[26].indicator_name}}(倍)</p>
      <p class="value">{{flowChart[26].fact_value}}</p>
    </div>
    <!-- 11 -->
    <div class="node node-row-11-1">
      <p class="key">{{flowChart[13].indicator_name}}(%)</p>
      <p class="value">{{flowChart[13].fact_value}}</p>
    </div>
  
    <div class="node node-row-11-3">
      <p class="key">{{flowChart[27].indicator_name}}(倍)</p>
      <p class="value">{{flowChart[27].fact_value}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["flowChart"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
.wrap {
  width: 1330px;
  height: 1030px;
  position: relative;
   color:#fff;
}

.mul1 {
  top: 185px;
  left: 486px;
  position: absolute;
}
.mul2 {
  top: 185px;
  left: 854px;
  position: absolute;
}
.tit {
  font-size: 12px;
  top: 26px;
  left: 758px;
  position: absolute;
}

// 整体
.node {
  width: 146px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #bad2ed;
}
.key {
  font-size: 12px;
  height: 26px;
  line-height: 26px;
  background-color: #e5f0ff;
  position: relative;color:#000;
}
.value {
  border-top: 1px solid #bad2ed;
  height: 26px;
  line-height: 26px;
}

// 第一行
.node-row-1 {
  top: 20px;
  left: 600px;
  position: absolute;
}
// 线
.h-linktwo-1 {
  width: 486px;
  height: 20px;
  top: 75px;
  left: 424px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-linktwo-1.png") no-repeat;
  background-size: 100% 100%;
}
//  第二行
.node-row-2-1 {
  top: 94px;
  left: 352px;
  position: absolute;
}
.node-row-2-2 {
  top: 94px;
  left: 835px;
  position: absolute;
}
// 线
.div1 {
  width: 10px;
  height: 10px;
  top: 144px;
  left: 425px;
  color: #bad2ed;
  font-weight: bolder;
  position: absolute;
}
.div2 {
  width: 20px;
  height: 20px;
  top: 139px;
  left: 670px;
  background: #fff;
  z-index: 999;
  position: absolute;
}
.h-rootlink {
  width: 728px;
  height: 20px;
  top: 150px;
  left: 304px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-rootlink.png") no-repeat;
  background-size: 100% 100%;
}

//  第三行
.node-row-3-1 {
  top: 170px;
  left: 229px;
  position: absolute;
}
.node-row-3-2 {
  top: 170px;
  left: 604px;
  position: absolute;
}
.node-row-3-3 {
  top: 170px;
  left: 955px;
  position: absolute;
}

//  第四行
.node-row-4-1 {
  top: 258px;
  left: 148px;
  position: absolute;
}
.node-row-4-2 {
  top: 258px;
  left: 524px;
  position: absolute;
}
.node-row-4-3 {
  top: 258px;
  left: 875px;
  position: absolute;
}
// 线
.div3 {
  border-left: 1px solid #bad2ed;
  height: 593px;
  top: 225px;
  left: 303px;
  position: absolute;
}
.div4 {
  border-left: 1px solid #bad2ed;
  height: 441px;
  top: 225px;
  left: 680px;
  position: absolute;
}
.div5 {
  border-left: 1px solid #bad2ed;
  height: 593px;
  top: 225px;
  left: 1030px;
  position: absolute;
}
.div6 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 285px;
  left: 296px;
  position: absolute;
}
.div7 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 285px;
  left: 672px;
  position: absolute;
}
.div8 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 285px;
  left: 1023px;
  position: absolute;
}

.div9 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 361px;
  left: 296px;
  position: absolute;
}
.div10 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 361px;
  left: 672px;
  position: absolute;
}
.div11 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 361px;
  left: 1023px;
  position: absolute;
}

.div12 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 437px;
  left: 296px;
  position: absolute;
}
.div13 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 437px;
  left: 672px;
  position: absolute;
}
.div14 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 437px;
  left: 1023px;
  position: absolute;
}

.div15 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 513px;
  left: 296px;
  position: absolute;
}
.div16 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 513px;
  left: 672px;
  position: absolute;
}
.div17 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 513px;
  left: 1023px;
  position: absolute;
}

.div18 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 589px;
  left: 296px;
  position: absolute;
}
.div19 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 589px;
  left: 672px;
  position: absolute;
}
.div20 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 589px;
  left: 1023px;
  position: absolute;
}

.div21 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 665px;
  left: 296px;
  position: absolute;
}
.div22 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 665px;
  left: 672px;
  position: absolute;
}
.div23 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 665px;
  left: 1023px;
  position: absolute;
}

.div24 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 741px;
  left: 296px;
  position: absolute;
}
 
.div26 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 741px;
  left: 1023px;
  position: absolute;
}
.div27 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 817px;
  left: 296px;
  position: absolute;
}
.div28 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 817px;
  left: 1023px;
  position: absolute;
}

// 第五行
.node-row-5-1 {
  top: 334px;
  left: 148px;
  position: absolute;
}

.node-row-5-2 {
  top: 334px;
  left: 524px;
  position: absolute;
}

.node-row-5-3 {
  top: 334px;
  left: 875px;
  position: absolute;
}

// 第六行
.node-row-6-1 {
  top: 410px;
  left: 148px;
  position: absolute;
}
.node-row-6-2 {
  top: 410px;
  left: 524px;
  position: absolute;
}
.node-row-6-3 {
  top: 410px;
  left: 875px;
  position: absolute;
}
// 第7行
.node-row-7-1 {
  top: 486px;
  left: 112px;
  position: absolute;
  width: 182px; 
} 
.node-row-7-2 {
  top: 486px;
  left: 524px;
  position: absolute;
}
.node-row-7-3 {
  top: 486px;
  left: 875px;
  position: absolute;
}
// 第8行
.node-row-8-1 {
  top: 562px;
  left: 148px;
  position: absolute;
}
.node-row-8-2 {
  top: 562px;
  left: 524px;
  position: absolute;
}
.node-row-8-3 {
  top: 562px;
  left: 875px;
  position: absolute;
}
// 第9行
.node-row-9-1 {
  top: 638px;
  left: 148px;
  position: absolute;
}
.node-row-9-2 {
  top: 638px;
  left: 524px;
  position: absolute;
}
.node-row-9-3 {
  top: 638px;
  left: 839px;
  position: absolute;
  width: 182px; 

}
// 第10行
.node-row-10-1 {
  top: 714px;
  left: 148px;
  position: absolute;
}
 
.node-row-10-3 {
  top: 714px;
  left: 875px;
  position: absolute;
}
// 第11行
.node-row-11-1 {
  top: 790px;
  left: 148px;
  position: absolute;
}
.node-row-11-3 {
  top: 790px;
  left: 875px;
  position: absolute;
}
</style>







// WEBPACK FOOTER //
// src/components/analyze/palepu.vue